export const partitionAsync = async (source, predicate) => {
    const fail = [];
    const pass = [];
    for await (const value of source) {
        if (await predicate(value) === true) {
            pass.push(value);
        }
        else {
            fail.push(value);
        }
    }
    return [pass, fail];
};
